import React from 'react';
import SeverityChip from './SeverityChip';

interface Props {
  status: string;
  size?: 'small' | 'medium';
}

// Map ETL run statuses onto the four severity colors so the dashboard
// stays visually consistent: success→OK, failed→CRITICAL, running→MAJOR, pending→MINOR.
const STATUS_TO_SEVERITY: Record<string, string> = {
  success: 'OK',
  failed: 'CRITICAL',
  running: 'MAJOR',
  pending: 'MINOR',
};

const StatusChip: React.FC<Props> = ({ status, size = 'small' }) => {
  const severity = STATUS_TO_SEVERITY[status] || status.toUpperCase();
  return <SeverityChip severity={severity} size={size} />;
};

export default StatusChip;
